import React from 'react';
import PropTypes from 'prop-types';
import SelectInput from '../../../../../../web-app-components/components/SelectInput';
import MenuItem from '@material-ui/core/MenuItem';

export const filters = {
  ALL: 'all',
  NEW: 'new',
  EDIT: 'edit',
};

const filtersArray = Object.values(filters);

const FilterSelectInput = (props) => {
  return (
    <SelectInput {...props}>
      <MenuItem value={filters.ALL}>Visos</MenuItem>
      <MenuItem value={filters.NEW}>Naujas</MenuItem>
      <MenuItem value={filters.EDIT}>Esamas</MenuItem>
    </SelectInput>
  );
};

FilterSelectInput.propTypes = {
  value: PropTypes.oneOf(filtersArray).isRequired,
};

export default FilterSelectInput;
